var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "check-white_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 1161.1 1161.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M475.6 812.1h-.2c-8.6-.1-16.9-3.6-23-9.7L259.8 606.3c-12.6-12.8-12.4-33.4.4-46 12.8-12.6 33.4-12.4 46 .4l169.7 172.8 379.3-375.2c12.8-12.6 33.3-12.5 46 .2 12.6 12.8 12.5 33.3-.2 46L498.5 802.7c-6.1 6.1-14.3 9.4-22.9 9.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckWhite);
export default ForwardRef;